import cn from "@utils/cn";
import { formatEventDate } from "@utils/dateUtils";
import { useLocale, useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import NextImage from "next/image";
import React, { FC, useMemo } from "react";

import { ImageElement } from "@/types";

interface Props {
  title?: string;
  description?: string;
  image?: ImageElement;
  slug?: string;
  eventDate?: string;
  eventLocaltion?: string;
}

const ForSalesCard: FC<Props> = ({ title, description, image, slug, eventDate, eventLocaltion }) => {
  const locale = useLocale();
  const t = useTranslations();

  const forSalePageLink = useMemo(() => {
    return `/${locale}/${slug}`;
  }, [slug, locale]);
  console.log("============ title", title, description, image, slug, eventDate, eventLocaltion);
  return (
    <>
      <a
        href={forSalePageLink}
        className={cn(
          "relative mb-l md:mb-0",
          "flex flex-col rounded-lg shadow-strong overflow-hidden",
          "cursor-pointer",
          `rounded-lg shadow-strong bg-top bg-no-repeat flex items-end overflow-hidden`,
        )}
      >
        {
          <div className={`relative aspect-video h-[200px] w-full`}>
            <NextImage src={image?.url || ""} alt={""} fill className={`object-cover`} priority />
            {eventDate && (
              <div
                className="absolute top-[10px] left-[10px] w-auto px-xxs py-xxs text-white text-s font-secondary-light rounded-s"
                style={{ backgroundColor: "rgba(128, 128, 128, 0.80)" }}
              >
                {formatEventDate(eventDate, locale)}
              </div>
            )}
          </div>
        }

        <div className={cn(`w-full  relative z-[2] h-[40%]"}`, "bg-white", "pr-[4px] px-s")}>
          {<div className="mb-s mt-s font-secondary-light text-s uppercase">{eventLocaltion ? eventLocaltion : t("for-sale")}</div>}

          <h3 className="text-m font-medium line-clamp-2 h-[41px] overflow-hidden">{title}</h3>
          <div className="mt-[6px] text-s font-secondary-light mb-s line-clamp-3 pr-s" dangerouslySetInnerHTML={{ __html: description ?? "" }} />
        </div>
      </a>
    </>
  );
};

export default ForSalesCard;
